import React, { useState } from 'react';
import { supabase } from '../lib/supabaseClient';

export default function PrayerRequest() {
  const [publish, setPublish] = useState(false);
  const [form, setForm] = useState({ name: '', phone: '', address: '', prayer_request: '' });
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.prayer_request.trim()) return;
    setStatus('sending');
    const { error } = await supabase.from('prayer_requests').insert([{
      name: form.name,
      phone: form.phone || null,
      address: form.address || null,
      prayer_request: form.prayer_request,
      allow_publish: publish,
      status: 'pending',
    }]);
    if (!error) {
      setForm({ name: '', phone: '', address: '', prayer_request: '' });
      setPublish(false);
      setStatus('success');
    } else {
      setStatus('error');
    }
  };

  return (
    <section id="prayer" className="section" style={{ background: 'linear-gradient(180deg,var(--bg-deep) 0%,var(--bg-dark) 100%)' }}>
      <div className="container">
        <div style={{ textAlign: 'center' }}>
          <span className="section-tag">✦ We Pray With You</span>
          <h2 className="section-title">Prayer <span>Request</span></h2>
          <div className="divider center" />
        </div>

        <form onSubmit={handleSubmit} style={{ maxWidth: 680, margin: '0 auto', background: 'var(--card-bg)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: 20, padding: '48px 40px' }} className="fade-up">
          <h3 style={{ fontFamily: "'Cinzel Decorative', serif", fontSize: '1.1rem', color: 'var(--primary)', marginBottom: 8, textAlign: 'center' }}>✝ Submit Your Prayer Request</h3>
          <p style={{ fontFamily: "'Crimson Pro', serif", fontStyle: 'italic', color: 'var(--text-muted)', textAlign: 'center', marginBottom: 32, fontSize: '1rem' }}>
            "Do not be anxious about anything, but in every situation, by prayer…" — Philippians 4:6
          </p>

          {status === 'success' && (
            <div style={{ background: 'rgba(201,168,76,0.12)', border: '1px solid rgba(201,168,76,0.4)', borderRadius: 12, padding: '16px 20px', marginBottom: 24, textAlign: 'center', color: 'var(--primary-light)', fontFamily: "'Crimson Pro', serif", fontSize: '1rem' }}>
              🙏 Your prayer request has been received. Our prayer team will pray for you every day. God bless you!
            </div>
          )}
          {status === 'error' && (
            <div style={{ background: 'rgba(178,34,34,0.12)', border: '1px solid rgba(178,34,34,0.4)', borderRadius: 12, padding: '16px 20px', marginBottom: 24, textAlign: 'center', color: '#ff8a8a', fontFamily: "'Crimson Pro', serif", fontSize: '1rem' }}>
              ❌ Something went wrong. Please try again.
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }} className="pr-form-row">
            <div className="form-group" style={{ margin: 0 }}>
              <label>Full Name *</label>
              <input type="text" placeholder="Your name" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Phone Number</label>
              <input type="tel" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} />
            </div>
          </div>

          <div className="form-group">
            <label>Address</label>
            <input type="text" placeholder="Your location / city" value={form.address} onChange={e => setForm(f => ({ ...f, address: e.target.value }))} />
          </div>

          <div className="form-group">
            <label>Prayer Request *</label>
            <textarea placeholder="Share your prayer need with us. We will pray for you…" value={form.prayer_request} onChange={e => setForm(f => ({ ...f, prayer_request: e.target.value }))} required />
          </div>

          {/* Publish toggle */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 18px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: 10, marginBottom: 20, cursor: 'pointer' }}
            onClick={() => setPublish(p => !p)}>
            <div style={{ width: 44, height: 24, borderRadius: 24, flexShrink: 0, position: 'relative', background: publish ? 'var(--primary)' : 'rgba(255,255,255,0.12)', transition: 'background 0.3s' }}>
              <div style={{ position: 'absolute', top: 3, left: publish ? 23 : 3, width: 18, height: 18, borderRadius: '50%', background: publish ? 'var(--bg-deep)' : 'var(--text-muted)', transition: 'left 0.3s' }} />
            </div>
            <span style={{ fontSize: '0.84rem', color: 'var(--text-muted)', lineHeight: 1.5 }}>
              Allow this prayer request to be shared publicly so others can pray for me
            </span>
          </div>

          <button type="submit" className="btn-primary" style={{ width: '100%', fontSize: '0.9rem', opacity: status === 'sending' ? 0.7 : 1 }} disabled={status === 'sending'}>
            {status === 'sending' ? '⏳ Sending…' : '🙏 Submit Prayer Request'}
          </button>
          <p style={{ textAlign: 'center', fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 16 }}>
            Your request will be shared with our prayer team. We pray for every request, every day.
          </p>
        </form>
      </div>
      <style>{`@media(max-width:600px){ .pr-form-row{ grid-template-columns:1fr !important; } }`}</style>
    </section>
  );
}
